import { Outlet } from "react-router-dom";
import SellerAuthHeader from "@/components/seller/auth/SellerAuthHeader";
import SellerAuthFooter from "@/components/seller/auth/SellerAuthFooter";

const SellerAuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-godyspo-background">
      <SellerAuthHeader />
      
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      
      <SellerAuthFooter />
    </div>
  );
};

export default SellerAuthLayout;
